<template>
    <div>
        <commonHeader v-if="channel == '014'" title=" " />
        <div class="download">
            <div class="logo">
                <img src="https://s.jihaimall.com/h5/image/down/jh_title_ty.png" alt="">
            </div>
            <div class="swipe">
                <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                    <van-swipe-item><img src="https://img0.jihai8.com/jhimg/4b9a773240ea885577f272177c96206a.png" alt=""></van-swipe-item>
                    <van-swipe-item><img src="https://img0.jihai8.com/jhimg/3d3648f7a2b1ce5a3dc2102a564ae001.png" alt=""></van-swipe-item>
                    <van-swipe-item><img src="https://img0.jihai8.com/jhimg/b7c4f446e12cee8d3587ff0cffd2ee65.png" alt=""></van-swipe-item>
                    <van-swipe-item><img src="https://img0.jihai8.com/jhimg/0d5789156375a3d1fd358b22b0056eb2.png" alt=""></van-swipe-item>
                    <van-swipe-item><img src="https://img0.jihai8.com/jhimg/937a03c905cc4e38c4999d7231964da8.png" alt=""></van-swipe-item>
                </van-swipe>
            </div>
            <div class="bottom" id="download">
                <div class="btn" :class="{backHuawei: channel == '014'}">
                    {{ channel != '014' ? '立即下载' : '应用商店搜索"即嗨体育"即可下载～' }}
                </div>
            </div>
            <div class="tips">西藏嗨娱网络科技有限公司</div>
        </div>
    </div>

</template>

<script>
import { importSdk } from "@/utils/tools";
import jsbridg from "@/utils/jsbridg.js"
import commonHeader from "@/components/common/commonHeader"
export default {
    name: 'download',
    components: {
        commonHeader
    },
    data () {
        return {
            channel: this.$route.query.channel
        }
    },
    mounted () {
        if (this.channel !== '014') {
            importSdk("https://web.cdn.openinstall.io/openinstall.js", this.initOpenInstall);
        } else {
            document.getElementsByTagName('title')[0].innerHTML = ' ';
            jsbridg.setTitle(' ')
            jsbridg.hideAppBar(0);
        }
    },
    methods: {
        initOpenInstall () {
            /* eslint-disable*/
            var data = OpenInstall.parseUrlParams();///openinstall.js中提供的工具函数，解析url中的所有查询参数
            new OpenInstall({
                /*appKey必选参数，OpenInstall平台为每个应用分配的ID*/
                appKey : process.env.VUE_APP_OPENINSTALLAPPKEY,
                onready : function() {
                    /*在app已安装的情况尝试拉起app*/
                    this.schemeWakeup();
                    /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
                    var m = this;
                    var btn_1 = document.getElementById('download');
                    btn_1.style.visibility = "visible";
                    btn_1.onclick = function() {
                        m.wakeupOrInstall();
                        return false;
                    }
                }
            }, data);
        }
    }
}
</script>

<style lang="less" scoped>
.download {
    background-image: url('https://s.jihaimall.com/h5/image/down/shareback380.png');
    background-size: 100% 100vh;
    background-repeat: no-repeat;
    min-height: 100vh;
    .logo{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0px;
        img{
            width: 128px;
        }
    }
    .van-swipe-item {
        line-height: 100px;
    }
    /deep/.van-swipe__indicator {
        width: 10px;
        height: 10px;
    }
    .bottom {
        width: 100%;
        padding: 0 10px;
        // position: fixed;
        bottom: 20px;
        .btn {
            width: 100%;
            height: 53px;
            background: linear-gradient(180deg,#fd884e,#f76c2b 99%);
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 17px;
            font-weight: 600;
            color: #fff;
            // span {
            //     &:first-child {
            //         font-size: 17px;
            //         font-weight: 500;
            //         color: #AD1207;
            //     }
            //     &:last-child {
            //         font-size: 10px;
            //         font-weight: 400;
            //         color: #AD1207;
            //         margin-top: -3px;
            //     }
            // }
        }
        .backHuawei{
            background: transparent;
        }
    }
    .tips{
        font-size: 10px;
        color: #fff;
        margin-top: 20px;
        text-align: center;
    }
}
</style>
